import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./styles/PaymentTerms.css";

const PaymentTerms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />

      <div className="payment-terms-page">
        <div className="payment-terms-container">

          <div className="payment-header">
            <h1>Payment Terms & Billing Policy</h1>
            <p>
              Transparent billing practices for all GTELINQ products and services.
            </p>
          </div>

          <div className="payment-content">

            <section>
  <h2>1. Subscription Billing</h2>
  <p>
    GTELINQ is provided as a subscription-based software service. Subscription
    fees are determined based on the selected plan, number of licensed users,
    enabled modules, and agreed billing cycle. Access to the platform is granted
    only after successful payment confirmation and account activation.
  </p>
</section>

<section>
  <h2>2. Payment Schedule</h2>
  <p>
    All subscription fees are payable in advance for the selected subscription
    period. Customers may choose from monthly, quarterly, annual, or custom
    enterprise billing arrangements. Renewal payments must be completed before
    the subscription expiry date to ensure uninterrupted access to GTELINQ
    services and associated data.
  </p>
</section>

<section>
  <h2>3. Pricing</h2>
  <p>
    Subscription pricing varies based on the selected GTELINQ package,
    workforce size, enabled modules, integrations, implementation scope,
    and any additional enterprise requirements. GTELINQ reserves the right
    to revise pricing for future subscription periods. Existing customers
    will be notified in advance of any pricing changes applicable to their
    subscriptions.
  </p>
</section>

<section>
  <h2>4. GST & Taxes</h2>
  <p>
    All subscription fees are subject to applicable Goods and Services Tax (GST)
    as prescribed under Indian tax regulations. GST will be calculated and
    displayed during checkout and on all invoices issued by GTELINQ. Customers
    providing valid GST details may claim input tax credit in accordance with
    applicable laws and regulations.
  </p>
</section>

<section>
  <h2>5. Refund Policy</h2>
  <p>
    Subscription payments made to GTELINQ are non-refundable once payment has
    been successfully processed.
  </p>
</section>

<section>
  <h2>6. Subscription Upgrades & Downgrades</h2>
  <p>
    Customers may request upgrades to higher subscription plans at any time.
    Additional charges will be calculated on a prorated basis depending on the
    remaining subscription period. Downgrades may be applied at the next renewal
    cycle and may result in reduced access to certain features or modules.
  </p>
</section>

<section>
  <h2>7. Enterprise Services</h2>
  <p>
    Enterprise deployments, custom development, workflow automation,
    integrations, implementation support, dedicated infrastructure,
    white-label solutions, consulting services, and other customized
    engagements may be governed by separate commercial agreements,
    statements of work, or service contracts.
  </p>
</section>

<section>
  <h2>8. Currency & International Billing</h2>
  <p>
    Payments may be processed in Indian Rupees (INR), United States Dollars
    (USD), or other supported currencies depending on the customer's region,
    billing preferences, and applicable payment gateway support. Currency
    conversion rates, if applicable, may be determined by the customer's
    financial institution or payment provider.
  </p>
</section>

<section>
  <h2>9. Service Suspension for Non-Payment</h2>
  <p>
    GTELINQ reserves the right to suspend, restrict, or terminate access to
    services in the event of overdue payments, chargebacks, fraudulent
    transactions, or repeated payment failures. Access may be restored once
    outstanding balances have been cleared.
  </p>
</section>

<section>
  <h2>10. Contact Information</h2>
  <p>
    For billing inquiries, subscription assistance, enterprise pricing,
    invoice requests, payment-related concerns, or account management
    support, customers may contact us at:
  </p>

  <p>
    <strong>Email:</strong> erp@genesistech.co.in
    <br />
    <strong>Support Team:</strong> GTELINQ ERP Support
  </p>
</section>

            <div className="last-updated">
              Last Updated: June 2026
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PaymentTerms;